/* __next_internal_client_entry_do_not_use__ SDUISectionRenderer auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { SectionLoggingEventParams } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/types";
import React, { useMemo } from "react";
export var SDUISectionRenderer = function(param) {
    var section = param.section, componentRenderers = param.componentRenderers, sectionRenderers = param.sectionRenderers, viewLoggingData = param.viewLoggingData, loadTimingRef = param.loadTimingRef, UPLTprops = param.UPLTprops, shouldRenderBelowTheFold = param.shouldRenderBelowTheFold, onClickClientDismissHandler = param.onClickClientDismissHandler;
    var sectionLoggingData = useMemo(function() {
        return SectionLoggingEventParams.build(_object_spread({}, viewLoggingData, section.logging_data));
    }, [
        viewLoggingData,
        section.logging_data
    ]);
    var SectionRenderer = getSectionRenderer(section, sectionRenderers);
    if (!SectionRenderer) {
        return null;
    }
    return /*#__PURE__*/ _jsx(SectionRenderer, {
        section: section,
        componentRenderers: componentRenderers,
        sectionLoggingData: sectionLoggingData,
        loadTimingRef: loadTimingRef,
        shouldRenderBelowTheFold: shouldRenderBelowTheFold,
        UPLTprops: UPLTprops,
        onClickClientDismissHandler: onClickClientDismissHandler
    });
};
var getSectionRenderer = function(section, sectionRenderers) {
    if (section.column_section) {
        return sectionRenderers["column_section"];
    } else if (section.filterable_paginated_section) {
        return sectionRenderers["filterable_paginated_section"];
    } else if (section.rotating_section) {
        return sectionRenderers["rotating_section"];
    }
    return undefined;
};
